import React, { useState } from 'react';

import { bool, func, number, shape, string } from 'prop-types';

import Button from 'components/Common/Buttons/ButtonV3';
import Checkbox from 'components/Common/Checkbox';
import Flexbox from 'components/Common/Flexbox';
import Text from 'components/Common/Text';

import TextInput from 'components/Common/TextInput';

import s from './SignatureInput.css';

const SignatureInput = ({
  contextId,
  error,
  handleDeleteResponse,
  handleSaveResponse,
  initialValue,
  prompt,
  responseId,
  setManualClose,
}) => {
  const [signature, setSignature] = useState(initialValue);
  const [checked, setChecked] = useState(true);
  const [checkedError, setCheckedError] = useState(false);

  const handleSubmit = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!checked) {
      setCheckedError(true);
      return;
    }
    setCheckedError(false);
    if (signature) {
      handleSaveResponse({ value: signature, prompt, isText: true });
    } else {
      handleDeleteResponse({ promptId: prompt.id, contextId, responseId });
    }
    setManualClose(true);
  };

  return (
    <form onSubmit={handleSubmit} className={s.root}>
      <Text variant="titleMdBold" mb={1.5}>
        {prompt.text}
      </Text>
      <TextInput
        error={error}
        fullWidth
        onChange={e => setSignature(e.target.value)}
        rootClass={s.signature}
        value={signature}
      />
      <Checkbox
        checked={checked}
        classes={{
          root: s.checkbox,
        }}
        errorText="Required"
        hasError={Boolean(checkedError)}
        label="By providing my signature, I certify that all the information I provided is accurate."
        onChange={() => setChecked(!checked)}
        removeOffset
      />
      <Flexbox justifyContent="flex-end" gap={2} mt={1.5}>
        <Button
          color="gray"
          label="Cancel"
          onClick={e => {
            e.stopPropagation();
            setManualClose(true);
          }}
          size="small"
          variant="text"
        />
        <Button
          label="Save"
          size="small"
          onClick={handleSubmit}
          type="submit"
          variant="filled"
        />
      </Flexbox>
    </form>
  );
};

SignatureInput.propTypes = {
  contextId: number,
  error: bool,
  handleDeleteResponse: func.isRequired,
  handleSaveResponse: func.isRequired,
  initialValue: string,
  prompt: shape({}).isRequired,
  setManualClose: func.isRequired,
  responseId: number,
};

SignatureInput.defaultProps = {
  contextId: undefined,
  error: false,
  initialValue: '',
  responseId: undefined,
};

export default SignatureInput;
